import angular from 'angular';
import Pikaday from 'pikaday-time';
import moment from 'moment-timezone';

module.exports = angular.module('common.directives.pikaday', [])
.directive('pikaday', function typePikaday() {
  if (typeof(Pikaday) === 'undefined') {
    console.warn('pikaday directive requires the Pikaday library.');
    return {};
  }

  return {
    restrict: 'C',
    scope: {
      ngModel: '=',
      minDate: '=?',
      maxDate: '=?',
      showTime: '<?',
      timeIsNow: '<?',
      disableDay: '=?',
      defaultDate: '=?',
      onSelect: '&?',
      theme: '=?',
    },
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      var minDate = scope.minDate && moment(scope.minDate).toDate();
      var maxDate = scope.maxDate && moment(scope.maxDate).toDate();
      var defaultDate = (scope.defaultDate && moment(scope.defaultDate).toDate()) || minDate;
      var showTime = scope.showTime || false;
      var timeIsNow = scope.timeIsNow;
      var formatString = attrs.format || (showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD');
      var pickadayOptions = {
        field: element[0],
        defaultDate: defaultDate,
        setDefaultDate: !!scope.defaultDate,
        showTime: showTime,
        incrementMinuteBy: 15,
        minDate: minDate,
        maxDate: maxDate,
        format: formatString,
        theme: scope.theme,
      };

      if (scope.onSelect) {
        pickadayOptions.onSelect = function(date) {
          scope.onSelect({ date: date });
        };
      }

      if (scope.disableDay) {
        pickadayOptions.disableDayFn = scope.disableDay;
      }

      var pikaday = new Pikaday(pickadayOptions);

      var time = null;
      var dt = null;

      ngModel.$formatters.push(function(value) {
        if (!value) return;

        if (showTime) {
          if (timeIsNow !== false) {
              dt = moment(pikaday.getMoment());
          } else {
              dt = moment(value);
          }
        } else {
          dt = moment(value);
          time = moment(value);
          pikaday.setMoment(dt.toDate());
        }
        return dt.format(formatString);
      });

      ngModel.$parsers.push(function(value) {
        if (time && time.format('HH:mm:ss') !== '00:00:00') {
          return moment(value).hour(time.hour()).minute(time.minute()).second(time.second()).toDate(); // eslint-disable-line max-len
        } else {
          return value;
        }
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/pikaday.js
 **/